import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PitchContext } from "../context/PitchContex";

function PaymentSuccess() {
  const [bookingID, setBookingID] = useState(null);
  const { slug } = useParams();
  const {
    backendURL,
    setPending,
    setIsErr,
    setAlertMessage,
    setShowAlert,
    user,
  } = useContext(PitchContext);

  useEffect(() => {
    const handlePaymentFlow = async () => {
      const localBookingID = localStorage.getItem("bookingID");
      setBookingID(localBookingID);

      try {
        setPending(true);

        // 1. Fetch pitch info
        const pitchRes = await axios.post(`${backendURL}pitch/get/${slug}`, {});
        if (!pitchRes.data.success) {
          setAlertMessage("Saha bilgileri alınamadı.");
          setIsErr(true);
          setShowAlert(true);
          return;
        }
        const pitch = pitchRes.data.pitch;

        // 2. Send email
        const mailResponse = await axios.post(
          `${backendURL}payment/son`,
          {
            name: user.fullname,
            email: user.email,
            phone: user.phone,
            userNote: localStorage.getItem("userNote"),
            pitch,
            amount: localStorage.getItem("price") || 0,
            bookingID: localBookingID,
          },
          { headers: { "Content-Type": "application/json" } }
        );
        localStorage.removeItem("userNote");

        if (!mailResponse.data.success) {
          setAlertMessage("E-posta gönderilemedi.");
          setIsErr(true);
          setShowAlert(true);
          return;
        }

        // // 3. Send SMS
        // const smsResponse = await axios.post(
        //   backendURL + "booking/send-sms",
        //   {}
        // );
        // if (!smsResponse.data.success) {
        //   setAlertMessage("SMS gönderilemedi.");
        //   setIsErr(true);
        //   setShowAlert(true);
        //   return;
        // }

        setIsErr(false);
        setAlertMessage("Rezervasyonunuz başarıyla tamamlandı.");
        setShowAlert(true);
        console.log("SMS gönderildi.");

        // 4. Update payment status
        const statusRes = await axios.post(
          `${backendURL}booking/update-payment-status/${localBookingID}`,
          {}
        );
        if (!statusRes.data.success) {
          setAlertMessage("Ödeme durumu güncellenemedi.");
          setIsErr(true);
          setShowAlert(true);
          return;
        } else {
          console.log("Payment status updated successfully");
        }

        // 5. Create order
        const bookingTime = localStorage.getItem("bookingTime");
        const orderRes = await axios.post(backendURL + "order/create", {
          user: user._id,
          pitch: localStorage.getItem("pitchID"),
          amount: localStorage.getItem("price"),
          orderID: localStorage.getItem("orderID"),
          ownerID: localStorage.getItem("ownerID"),
          transactionID:
            localStorage.getItem("orderID") + localStorage.getItem("price"),
          bookingTime,
        });

        if (!orderRes.data.success) {
          setAlertMessage("Sipariş oluşturulamadı.");
          setIsErr(true);
          setShowAlert(true);
          return;
        } else {
          console.log("Order created successfully:", orderRes.data.order);
        }

        // 6. Clean up
        localStorage.removeItem("bookingID");
        localStorage.removeItem("orderID");
        localStorage.removeItem("bookingTime");
        localStorage.removeItem("ownerID");
        localStorage.removeItem("price");
        localStorage.removeItem("pitchID");
        localStorage.removeItem("iframeToken");
      } catch (err) {
        setIsErr(true);
        setAlertMessage(
          err.message || "Bir hata oluştu. Lütfen tekrar deneyin."
        );
        setShowAlert(true);
      } finally {
        setPending(false);
      }
    };

    handlePaymentFlow();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 text-center">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-xl w-full">
        <div className="text-[72px] mb-4">✅</div>
        <h1 className="text-3xl font-semibold mb-4 text-gray-800">
          Ödeme Durumu
        </h1>
        <p className="text-xl text-gray-700 mb-6">Ödeme başarılı!</p>
        {bookingID && (
          <div className="bg-gray-100 rounded-lg p-4 text-base text-gray-700 font-mono mb-4">
            <strong>Rezervasyon Kodu:</strong> {bookingID}
          </div>
        )}
        <p className="text-base text-green-700 font-medium">
          Rezervasyon bilgileriniz e-posta ve SMS yoluyla size iletilmiştir.
        </p>
      </div>
    </div>
  );
}

export default PaymentSuccess;
